
/* eslint-disable arrow-parens */
import { combineReducers } from 'redux';
import queryString from 'query-string';
import { takeLatest, takeEvery, call, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import dedent from 'dedent';
import PromiseCreator from 'promise-creator';
import get from 'lodash.get';
import { SubmissionError } from 'redux-form';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';
import { showSnackbarAction } from './snackbar';
import { showAlert } from './alert';
import {
    openPromptAction,
    showPromptErrorAction,
    closePromptAction,
} from './prompt';

export const SEARCH_SCHOOLS = 'programs-schools/SEARCH_SCHOOLS';
export const SEARCH_PROGRAMS = 'programs-schools/SEARCH_PROGRAMS';
export const REMOVE_SCHOOL = 'programs-schools/REMOVE_SCHOOL';
export const REMOVE_PROGRAM = 'programs-schools/REMOVE_PROGRAM';
export const UPDATE_SCHOOL = 'programs-schools/UPDATE_SCHOOL';
export const UPDATE_PROGRAM = 'programs-schools/UPDATE_PROGRAM';
export const ADD_SCHOOL = 'programs-schools/ADD_SCHOOL';
export const ADD_PROGRAM = 'programs-schools/ADD_PROGRAM';
export const FETCH_SCHOOL = 'programs-schools/FETCH_SCHOOL';
export const FETCH_PROGRAM = 'programs-schools/FETCH_PROGRAM';
export const SELECT_USER_TO_MOVE = 'programs-schools/SELECT_USER_TO_MOVE';
export const CHANGE_FILTER = 'programs-schools/CHANGE_FILTER';
export const DEFAULT_FILTER = 'programs-schools/DEFAULT_FILTER';
export const BULK_UPLOAD = 'programs-schools/BULK_UPLOAD';
export const HAVE_ARCHIVED_CHECK = 'programs-schools/HAVE_ARCHIVED_CHECK';

export const schoolList = (state = {}, action) => {
    switch (action.type) {
        case actionKey.success(SEARCH_SCHOOLS):
            return {
                ...state,
                ...action.payload.schools.reduce((acc, program) => {
                    acc[program.schoolProgramsID_PK] = {
                        // eslint-disable-line no-param-reassign
                        ...program,
                    };
                    return acc;
                }, {}),
            };
        case actionKey.success(UPDATE_SCHOOL):
            return {
                ...state,
                [action.payload.school.schoolProgramsID_PK]:
                    action.payload.school,
            };
        // case actionKey.success(FETCH_SCHOOL):
        //     return {
        //         ...state,
        //         [action.payload.program.schoolProgramsID_PK]: action.payload.school,
        //     };
        default:
            return state;
    }
};

export const programList = (state = {}, action) => {
    switch (action.type) {
        case actionKey.success(SEARCH_PROGRAMS):
            return {
                ...state,
                ...action.payload.programs.reduce((acc, program) => {
                    acc[program.customProgramsID_PK] = {
                        // eslint-disable-line no-param-reassign
                        ...program,
                    };
                    return acc;
                }, {}),
            };
        case actionKey.success(UPDATE_PROGRAM):
            return {
                ...state,
                [action.payload.program.customProgramsID_PK]:
                    action.payload.program,
            };
        // case actionKey.success(FETCH_PROGRAM):
        //     return {
        //         ...state,
        //         [action.payload.program.customProgramsID_PK]: action.payload.program,
        //     };
        default:
            return state;
    }
};

export const schools = (state = [], action) => {
    switch (action.type) {
        case actionKey.success(FETCH_SCHOOL):
            return action.payload.schools;
        case actionKey.success(REMOVE_SCHOOL):
            return state.filter(
                (id) => id.schoolProgramsID_PK !== action.payload,
            );
        // case actionKey.success(ADD_SCHOOL): {
        //     const companyId = Number(action.payload.schools.schoolProgramsID_PK);
        //     return state.map(company => ({
        //         ...company,
        //         havePrograms: (
        //             company.havePrograms ||
        //             company.companyID_PK === companyId
        //         ),
        //     }));
        // }
        // case actionKey.success(UPDATE_SCHOOL): {
        //     const companyId = Number(action.payload.school.schoolProgramsID_PK);
        //     return state.map(company => ({
        //         ...company,
        //         havePrograms: (
        //             company.havePrograms ||
        //             company.schoolProgramsID_PK === companyId
        //         ),
        //     }));
        // }
        default:
            return state;
    }
};

export const maxReached = (state = false, action) => {
    switch (action.type) {
        case SEARCH_SCHOOLS:
            return false;
        case actionKey.success(SEARCH_SCHOOLS):
            return action.payload.schools.length < 10;
        case SEARCH_PROGRAMS:
            return false;
        case actionKey.success(SEARCH_PROGRAMS):
            return action.payload.programs.length < 10;
        default:
            return state;
    }
};

export const searchList = (state = [], action) => {
    switch (action.type) {
        case actionKey.init(SEARCH_SCHOOLS): {
            if (action.offset !== 0) {
                return state;
            }
            return [];
        }
        case actionKey.success(SEARCH_SCHOOLS):
            return [...state, ...action.payload.schools];
        case actionKey.success(REMOVE_SCHOOL):
            return state.filter(
                (id) => id.collegeProgramID_PK !== action.payload,
            );
        default:
            return state;
    }
};

export const searchProgramsList = (state = [], action) => {
    switch (action.type) {
        case actionKey.init(SEARCH_PROGRAMS): {
            if (action.offset !== 0) {
                return state;
            }
            return [];
        }
        case actionKey.success(SEARCH_PROGRAMS):
            return [...state, ...action.payload.programs];
        case actionKey.success(REMOVE_SCHOOL):
            return state.filter(
                (id) => id.collegeProgramID_PK !== action.payload,
            );
        default:
            return state;
    }
};

export const loading = (state = null, action) => {
    switch (action.type) {
        case CHANGE_FILTER:
        case SEARCH_SCHOOLS:
            return true;
        case actionKey.success(SEARCH_SCHOOLS):
        case actionKey.failure(SEARCH_SCHOOLS):
            return false;
        case SEARCH_PROGRAMS:
            return true;
        case actionKey.success(SEARCH_PROGRAMS):
        case actionKey.failure(SEARCH_PROGRAMS):
            return false;
        default:
            return state;
    }
};

export const errorReducer = (state = null, action) => {
    switch (action.type) {
        case SEARCH_SCHOOLS:
        case actionKey.success(SEARCH_SCHOOLS):
            return null;
        case actionKey.failure(SEARCH_SCHOOLS):
            return action.error;
        case SEARCH_PROGRAMS:
        case actionKey.success(SEARCH_PROGRAMS):
            return null;
        case actionKey.failure(SEARCH_PROGRAMS):
            return action.error;
        default:
            return state;
    }
};

export const schoolsLoading = (state = false, action) => {
    switch (action.type) {
        case FETCH_SCHOOL:
            return true;
        case actionKey.success(FETCH_SCHOOL):
        case actionKey.failure(FETCH_SCHOOL):
            return false;
        default:
            return state;
    }
};

export const filter = (state = {}, action) => {
    switch (action.type) {
        case actionKey.success(FETCH_SCHOOL): {
            const school = action.payload.schools[0];
            if (!school) {
                return state;
            }
            return {
                ...state,
                schoolId: 0,
            };
        }
        case DEFAULT_FILTER:
            return {
                ...action.payload.initialFilter,
            };
        case CHANGE_FILTER: {
            const newState = {
                ...state,
                ...action.payload,
            };
            newState.offset = action.payload.offset || 0;
            return newState;
        }
        case actionKey.init(SEARCH_SCHOOLS): {
            if (typeof action.query === 'undefined') {
                return {
                    ...state,
                    query: '',
                };
            }
            return state;
        }
        case actionKey.init(SEARCH_PROGRAMS): {
            if (typeof action.query === 'undefined') {
                return {
                    ...state,
                    query: '',
                };
            }
            return state;
        }
        default:
            return state;
    }
};

export const empty = (state = false, action) => {
    switch (action.type) {
        case SEARCH_SCHOOLS:
            return false;
        case actionKey.success(SEARCH_SCHOOLS):
            return (
                !action.query &&
                (!action.payload.users || action.payload.users.length === 0) &&
                (!action.offset || action.offset === 0)
            );
        case actionKey.success(SEARCH_PROGRAMS):
            return (
                !action.query &&
                (!action.payload.users || action.payload.users.length === 0) &&
                (!action.offset || action.offset === 0)
            );
        default:
            return state;
    }
};

export const initialLoading = (state = true, action) => {
    switch (action.type) {
        case DEFAULT_FILTER:
            return true;
        case actionKey.init(SEARCH_SCHOOLS):
            return typeof action.query === 'undefined';
        case actionKey.success(SEARCH_SCHOOLS):
        case actionKey.failure(SEARCH_SCHOOLS):
            return false;
        case actionKey.init(SEARCH_PROGRAMS):
            return typeof action.query === 'undefined';
        case actionKey.success(SEARCH_PROGRAMS):
        case actionKey.failure(SEARCH_PROGRAMS):
            return false;
        default:
            return state;
    }
};

export const haveArchived = (state = false, action) => {
    switch (action.type) {
        case actionKey.success(HAVE_ARCHIVED_CHECK):
            return action.payload.archived;
        default:
            return state;
    }
};

export default combineReducers({
    filter,
    loading,
    schools,
    schoolsLoading,
    list: schoolList,
    programList,
    search: searchList,
    searchPrograms: searchProgramsList,
    initialLoading,
    empty,
    maxReached,
});

/**
 * REDUX ACTIONS
 */

export const searchFitScoresAction = () => ({
    type: SEARCH_SCHOOLS,
});

export const searchFitProgramsAction = () => ({
    type: SEARCH_PROGRAMS,
});

export const addSchoolAction = (body, resolve, reject) => ({
    type: ADD_SCHOOL,
    body,
    resolve,
    reject,
});

export const addProgramAction = (payload, { resolve, reject } = {}) => ({
    type: ADD_PROGRAM,
    payload,
    resolve,
    reject,
});

export const fetchSchoolsAction = () => ({
    type: FETCH_SCHOOL,
});

export const fetchProgramAction = (payload) => ({
    type: FETCH_PROGRAM,
    payload,
});

export const changeFilterAction = (payload) => ({
    type: CHANGE_FILTER,
    payload,
});

export const updateProgramAction = (payload, { resolve, reject } = {}) => ({
    type: UPDATE_PROGRAM,
    payload,
    resolve,
    reject,
});

export const removeProgramAction = (payload) => ({
    type: REMOVE_PROGRAM,
    payload,
});

export const removeSchoolAction = (payload) => ({
    type: REMOVE_SCHOOL,
    payload,
});

export const updateSchoolAction = (payload, { resolve, reject } = {}) => ({
    type: UPDATE_SCHOOL,
    payload,
    resolve,
    reject,
});

export const defaultFilterAction = (payload) => ({
    type: DEFAULT_FILTER,
    payload,
});

export const bulkUploadAction = (payload, { resolve, reject } = {}) => ({
    type: BULK_UPLOAD,
    payload,
    resolve,
    reject,
});

/**
 * SAGA LISTENERS
 */

export function* rootSaga() {
    yield [
        takeLatest(
            [
                actionKey.success(ADD_SCHOOL),
                actionKey.success(ADD_PROGRAM),
                actionKey.success(BULK_UPLOAD),
                actionKey.success(UPDATE_SCHOOL),
                actionKey.success(UPDATE_PROGRAM),
                actionKey.success(FETCH_SCHOOL),
                actionKey.success(REMOVE_PROGRAM),
                actionKey.success(REMOVE_SCHOOL),
            ],
            refreshManageSchoolList,
        ),
        takeEvery(
            [
                actionKey.failure(REMOVE_PROGRAM),
                actionKey.failure(REMOVE_SCHOOL),
            ],
            handleFailure,
        ),
        takeEvery(REMOVE_PROGRAM, removeProgram),
        takeEvery(REMOVE_SCHOOL, removeSchool),
        takeLatest(SEARCH_SCHOOLS, searchManageSchools),
        takeLatest(SEARCH_PROGRAMS, searchManagePrograms),
        takeEvery(FETCH_PROGRAM, fetchProgram),
        takeEvery(FETCH_SCHOOL, fetchSchools),
        takeEvery(UPDATE_SCHOOL, updateSchool),
        takeEvery(UPDATE_PROGRAM, updateProgram),
        takeLatest(CHANGE_FILTER, searchFitScoresOnChange),
        takeEvery(ADD_SCHOOL, addSchool),
        takeEvery(ADD_PROGRAM, addProgram),
        takeEvery(DEFAULT_FILTER, defaultFilterTrigger),
        takeEvery(BULK_UPLOAD, bulkUpload),
    ];
}

export function* refreshManageSchoolList() {
    yield put(changeFilterAction({ offset: 0 }));
}

export function* refreshFitScoresSearch() {
    yield put(changeFilterAction({ offset: 0 }));
    yield triggerFitScoresSearch();
}

export function* triggerFitScoresSearch() {
    yield put(searchFitScoresAction());
    yield put(searchFitProgramsAction());
}

export function* defaultFilterTrigger({ payload }) {
    if (payload.trigger) {
        yield triggerFitScoresSearch();
    }
}

export function* searchFitScoresOnChange(action) {
    if (action.payload.query) {
        yield call(delay, 350);
    }
    yield triggerFitScoresSearch();
}
/**
 * REDUX SAGAS
 */

export function* searchManagePrograms() {
    const { programsAndSchools } = yield select();
    const params = queryString.stringify(programsAndSchools.filter);
    yield call(request, {
        url: `/api/administration/custom-programs/programs?${params}`,
        type: SEARCH_PROGRAMS,
        ...programsAndSchools.filter,
    });
}

export function* removeProgram({ type, payload }) {
    const { promise, resolve } = PromiseCreator();
    const { programsAndSchools } = yield select();
    const program = programsAndSchools.programList[payload];
    yield put(
        openPromptAction({
            resolve,
            title: 'Remove Program',
            message: dedent`
            Are you sure you want to remove the ${get(program, 'name')} program?
        `,
            okButton: 'Remove',
            primary: 'ok',
            showLoading: true,
        }),
    );
    const remove = yield promise;
    if (remove) {
        const result = yield call(request, {
            url: `/api/administration/custom-programs/program/${payload}`,
            options: {
                method: 'DELETE',
            },
            type,
            payload,
        });
        if (result.error) {
            yield put(showPromptErrorAction(result.error));
            yield removeProgram({ type, payload });
            return;
        }
    }
    yield put(closePromptAction());
}

export function* removeSchool({ type, payload }) {
    const { promise, resolve } = PromiseCreator();
    const { programsAndSchools } = yield select();
    const program = programsAndSchools.list[payload];
    yield put(
        openPromptAction({
            resolve,
            title: 'Remove School',
            message: dedent`
            Are you sure you want to remove the ${get(program, 'name')} school?
        `,
            okButton: 'Remove',
            primary: 'ok',
            showLoading: true,
        }),
    );
    const remove = yield promise;
    if (remove) {
        const result = yield call(request, {
            url: `/api/administration/custom-programs/school/${payload}`,
            options: {
                method: 'DELETE',
            },
            type,
            payload,
        });
        if (result.error) {
            yield put(showPromptErrorAction(result.error));
            yield removeProgram({ type, payload });
            return;
        }
    }
    yield put(closePromptAction());
}

export function* searchManageSchools() {
    const { programsAndSchools } = yield select();
    const params = queryString.stringify(programsAndSchools.filter);
    yield call(request, {
        url: `/api/administration/custom-programs/schools?${params}`,
        type: SEARCH_SCHOOLS,
        ...programsAndSchools.filter,
    });
}

const noop = () => null;

export function* updateSchool({
    type,
    payload,
    resolve = noop,
    reject = noop,
}) {
    const newBody = {
        name: payload.name,
        logo: payload.logo,
        locations: JSON.stringify(payload.locations),
    };
    const result = yield call(request, {
        url: `/api/administration/custom-programs/school/${payload.schoolProgramsID_PK}`,
        options: {
            method: 'PUT',
            body: newBody,
        },
        type,
    });

    if (result.error) {
        reject(
            new SubmissionError({
                _error: result.error,
            }),
        );
        return;
    }
    resolve();
}

export function* updateProgram({
    type,
    payload,
    resolve = noop,
    reject = noop,
}) {
    const result = yield call(request, {
        url: `/api/administration/custom-programs/program/${payload.customProgramsID_PK}`,
        options: {
            method: 'PUT',
            body: payload,
        },
        type,
    });

    if (result.error) {
        reject(
            new SubmissionError({
                _error: result.error,
            }),
        );
        return;
    }
    resolve();
}

export function* addSchool({ type, body, resolve = noop, reject = noop }) {
    const newBody = {
        name: body.name,
        logo: body.logo,
        locations: JSON.stringify(body.locations),
    };
    const result = yield call(request, {
        url: '/api/administration/custom-programs/school',
        options: {
            method: 'POST',
            body: newBody,
        },
        type,
    });
    if (result.error) {
        reject(
            new SubmissionError({
                _error: result.error,
            }),
        );
        return;
    }
    resolve();
}

export function* fetchProgram({ type, payload }) {
    yield call(request, {
        url: `/api/administration/custom-programs/programs/${payload}`,
        type,
    });
}

export function* addProgram({ type, payload, resolve = noop, reject = noop }) {
    const result = yield call(request, {
        url: '/api/administration/custom-programs/program',
        options: {
            method: 'POST',
            body: payload,
        },
        type,
    });
    if (result.error) {
        reject(
            new SubmissionError({
                _error: result.error,
            }),
        );
        return;
    }
    resolve();
}

export function* fetchSchools({ type }) {
    yield call(request, {
        url: '/api/administration/custom-programs/schools-all',
        type,
    });
}

export function* handleFailure({ error }) {
    yield put(
        showSnackbarAction({
            message: error,
            type: 'failure',
            timeout: 5000,
        }),
    );
}

export function* bulkUpload({ type, payload, resolve = noop, reject = noop }) {
    const result = yield call(request, {
        url: '/api/administration/custom-programs/bulk',
        options: {
            method: 'POST',
            body: payload,
        },
        type,
    });
    if (result.error) {
        reject(
            new SubmissionError({
                _error: result.error,
            }),
        );
        return;
    }
    resolve();
    const { programs } = payload;
    yield put(
        showAlert({
            title: 'Program Upload Successuful',
            message: dedent` ${programs.length} programs were successfully uploaded school `,
            type: 'prompt',
            button: 'Close',
        }),
    );
}



// WEBPACK FOOTER //
// ./src/client/redux/programs-schools.js